<template>
  <div class="intro-title-wrapper">
    <div class="text-wrapper">
      <h1 class="title">{{ page.title }}</h1>
      <div class="h4 subtitle">{{ page.subtitle }}</div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'IntroTitle',
    props: {
      page: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style src="./IntroTitle.scss" lang="scss"></style>
